export * from './lang_1033';

export const NEGATIVE_PRACTICES = ['이직 의향', '번아웃'];

export const INT_TO_LEAVE_TXT = '이직 의향';

export const QUES_LEGEND_TYPE_HEATMAP = {
    번아웃: 3,
    '이직 의향': 3,
    '조직 추천 의향': 2,
    'eNPS(직원 순추천지수)': 2,
    eNPS: 2,
};

export const QUES_LEGEND_TYPE_DEEP_DIVE = {
    번아웃: 2,
    '이직 의향': 2,
};
